"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticatedRequest = void 0;
const query_string_1 = __importDefault(require("query-string"));
const types_1 = require("./types");
/**
 * Retrieves the proper base url for the supplied environment.
 *
 * @param {?Environment} environment Used to determine the current base url.
 * @returns {string} A base URL for the supplied environment.
 */
function baseURL(environment) {
    switch (environment) {
        case types_1.IEnvironment.Development:
            return "http://localhost:3000/api/";
        case types_1.IEnvironment.Staging:
            return "https://staging.mhbo.com/api/";
        default:
            return "https://www.mhbo.com/api/";
    }
}
/**
 * Creates a new fetch request utilizing the proper environment and
 * supplied credentials.
 *
 * @param {string} token A signed JWT for the current request.
 * @param {string} method The HTTP method to utilize for this request.
 * @param {string} uri The URI to the resource.
 * @param {?Environment} environment The current environment (defaults to production)
 * @param {?FetchExecutor} fetchExecutor An optional override to perform the HTTP request.
 * @returns {Promise<Response>} The result of the fetch call.
 */
function authenticatedRequest(token, method, uri, environment, fetchExecutor, body) {
    const request = fetchExecutor || fetch;
    const url = baseURL(environment) + uri;
    return request(url, {
        body: method === "POST" ? query_string_1.default.stringify(body) : null,
        headers: {
            Authorization: token ? `Bearer ${token}` : ``,
            "Content-Type": "application/x-www-form-urlencoded",
        },
        method,
    });
}
exports.authenticatedRequest = authenticatedRequest;
